<template>
	<div>
		<sBox title="Criar Extrato/Relatório">
			<div slot="tools">
				<template v-if="in_load">
					<button disabled class="btn btn-default btn-block btn-sm">
						<i class="fa fa-spin fa-spinner"></i>
						Trabalhando...
					</button>
				</template>
				<template v-else>
					<button
						@click="createTXT"
						class="btn btn-success btn-block btn-sm"
					>
						<i class="fa fa-plus"></i>
						Extrato
					</button>
				</template>
			</div>
			<div slot="body">
				<div class="row">
					<div class="col-sm-3">
						Tipo
						<select v-model="form.type" class="form-control">
							<option
								v-for="(tag, index) in tags"
								:key="index"
								:value="tag.value"
							>
								{{ tag.html }} ({{ tag.value }})
							</option>
						</select>
					</div>
					<div class="col-sm-1"></div>
					<div class="col-sm-2">
						<b>Ids da convocação</b>
						<input
							v-model="form.ids"
							type="text"
							placeholder="Ex: 89,97"
							class="form-control"
						/>
					</div>
					<div class="col-sm-3">
						<b>Mês Convocação</b>
						<input
							v-model="form.month"
							type="month"
							class="form-control"
						/>
					</div>

					<div class="col-sm-3">
						<b>Intervalo Coleta</b>
						<div class="input-group">
							<span class="input-group-addon">
								<i v-if="!isDate" class="fa fa-calendar"></i>
								<i
									v-else
									class="fa fa-calendar-times-o"
									@click="form.dIn = form.dEnd = ''"
								></i>
							</span>
							<div class="form-control" id="datepicker-trigger">
								<template v-if="isDate">
									{{ fDate(form.dIn) }} -
									{{ fDate(form.dEnd) }}
								</template>
								<template v-else> Escolher </template>
							</div>
						</div>
						<div class="cnt-airbnb">
							<div class="airbnb">
								<AirbnbStyleDatepicker
									id="wrapper-date"
									trigger-element-id="datepicker-trigger"
									:mode="'range'"
									:months-to-show="2"
									:date-one="form.dIn"
									:date-two="form.dEnd"
									:fullscreen-mobile="true"
									@date-one-selected="
										(val) => {
											form.dIn = val;
										}
									"
									@date-two-selected="
										(val) => {
											form.dEnd = val;
										}
									"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</sBox>
		<sBox title="Relátório de emissão de extratos">
			<div slot="body">
				<sTable
					ref="tabExt"
					actionRead="private-read-sd2000Extratos"
					:labels="labels"
					:actions="actions"
					:functions="functions"
					:tags="tags"
					@download="downloadDocument"
					@open="openDocument"
				/>

				<!-- actionDelete='private-delete-sd2000DeleteExtratos'-->
			</div>
		</sBox>
		<md-view ref="mdView" />
	</div>
</template>
<script>
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import eDate from 'js/date';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import mdView from './components/mdView';

	export default {
		components: { sTable, sBox, aBtn, mdView },
		data() {
			let iniData = new Date();
			iniData.setMonth(iniData.getMonth() - 1);

			let hoje = new Date();
			hoje.setDate(hoje.getDate() + 15);
			return {
				in_load: false,
				labels: [
					{ data: 'cod', label: 'Cod' },
					{
						data: ['uid.nome', 'uid.cpf'],
						label: 'Usuário',
						two: true,
					},
					{ data: 'event', label: 'Gerado em' },
					// {data: ['filters.dIn', 'filters.dEnd'], label: 'Intervalo', two: true },
					{ data: 'type', label: 'Tipo' },
				],
				actions: [
					// { emit : "open", color: "btn-primary", icon:"fa-gears", text: "Visualizar" },
					{
						emit: 'download',
						color: 'btn-success',
						icon: 'fa-download',
						text: 'Download',
					},
					// "delete",
				],
				functions: [
					{ cod: 'filters.dIn', fx: (val) => eDate(val, 'DD/MM/YY') },
					{
						cod: 'filters.dEnd',
						fx: (val) => eDate(val, 'DD/MM/YY'),
					},
					{
						cod: 'event',
						fx: (val) => eDate(val, 'DD/MM/YY HH:II:SS'),
					},
				],
				tags: [
					{
						cod: 'type',
						value: 'TXT',
						html: 'SD2000',
						color: 'success',
					},
					{
						cod: 'type',
						value: 'ALL-TXT',
						html: 'SD2000 REDUNDANTE',
						color: 'info',
					},
					{
						cod: 'type',
						value: 'CSV',
						html: 'Faturamento',
						color: 'warning',
					},
				],
				form: {
					type: 'TXT',
					ids: '',
					month: '',
					dIn: '',
					dEnd: '',
				},
				url: 'http://wbs.viasst.com.br/uploaded_files/public/sd2000_txts/',
			};
		},
		computed: {
			isDate() {
				return this.form.dIn != '' && this.form.dEnd != '';
			},
		},
		methods: {
			fDate(data, mask = 'DD xmxs') {
				let date = new Date(data);
				date.setDate(date.getDate() + 1);
				return eDate(date, mask);
			},
			openDocument(row) {
				this.$refs.mdView.open(row);
			},
			downloadDocument(row) {
				// console.log(row.data)
				this.downloadFile(this.url + row.file, row.data);
			},
			downloadFile(url, content, convert = true) {
				if (convert) content = window.btoa(content);
				let a = document.createElement('a');
				a.href = 'data:text/plain;base64,' + content;
				a.download = url.substr(url.lastIndexOf('/') + 1);
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},
			createTXT() {
				this.in_load = true;
				let type = '';
				if (this.form.type == 'TXT' || this.form.type == 'ALL-TXT')
					type = 'createTXTsd2000';
				if (this.form.type == 'CSV') type = 'createCSVsd2000'; //Criar pasta

				WBS.send(`private-custom-${type}`, this.form, (resp) => {
					// console.log(resp)
					this.in_load = false;
					if (resp.status == 'success') {
						this.downloadFile(
							this.url + resp.data.url,
							resp.data.content,
							false
						);
						this.$refs.tabExt.updateTable();
						toastr.success('Extrato gerado com sucesso!');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
		},
		mounted() {
			this.$emit('setHeader', ['Extratos', 'SD2000']);
		},
	};
</script>
<style>
	.airbnb-style-datepicker-wrapper {
		position: absolute !important;
		width: 600px !important;
		z-index: 100 !important;
		top: 41px !important;
		right: 0px !important;
		left: 0px !important;
	}
	div.datepicker-inner-wrapper {
		margin: 3px 0 0 0 !important;
	}
	.airbnb {
		position: absolute;
		right: 601px;
		top: -40px;
	}
	.cnt-airbnb {
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/sd2000/extratos/index.vue